export default __webpack_public_path__ + "static/media/0066.696bf5db.jpg";